// How the licences view is reached (LICENSE-CLEARANCE rows 4/9/10). Kept
// apart from Licences.tsx so the join path imports two one-liners, not the
// component: App.tsx needs these on every load, the view itself only when
// someone asks for it (it is lazy, and carries the ~30 kB notices JSON).

/** The standalone route: `/licences`, with or without a trailing slash. */
export function isLicencesPath(pathname: string): boolean {
  return /^\/licences\/?$/.test(pathname);
}

/** The in-page view's URL marker, so a reload or a shared link reopens it. */
export const LICENCES_HASH = '#licences';
